import { REGION } from '@ms/config/app'
import { getHeaders } from 'crypto-fetch/headers'
import { API_PREFIX } from 'composables/useRegion'
import { PENDING_CANCEL } from '@ms/config/message.js'

const baseURL = API_PREFIX
const platformHeaders = getHeaders()
let isCancel = false

const setHeaders = (xhr, headers) => {
  Object.keys(platformHeaders).forEach((key) => {
    xhr.setRequestHeader(key, platformHeaders[key])
  })
  if (headers) {
    Object.keys(headers).forEach((key) => {
      xhr.setRequestHeader(key, headers[key])
    })
  }
}

const createRequest = (key, requestTasks) => {
  const xhr = new XMLHttpRequest()
  requestTasks.set(key, xhr)
  return xhr
}

const createXhrRequest = () => {
  const handleReadyStateChange = (xhr, key, resolve, reject, requestTasks) => {
    return () => {
      if (xhr.readyState === 4) {
        requestTasks.delete(key)
        if (xhr.status === 200) {
          try {
            let res = JSON.parse(xhr.response)
            if (res.bizCode === 10000) {
              resolve(res)
            } else {
              reject(res)
            }
          } catch (error) {
            reject({ status: xhr.status, message: error.message })
          }
        } else {
          let message = 'error'
          if (isCancel) {
            message = PENDING_CANCEL
            isCancel = false
          }
          reject({ status: xhr.status, message })
        }
      }
    }
  }

  const requestTasks = new Map()

  async function upload(url = '', body = {}, progressListener, headers, key) {
    let xhr = createRequest(key, requestTasks)

    let urlPath = url.startsWith('/api') ? url : `${baseURL}${url}`

    if (process.env.PLATFORM === 'local') {
      urlPath = process.env.VUE_APP_ORIGIN.replace(/xx/g, REGION) + urlPath
    }

    return new Promise((resolve, reject) => {
      xhr.open('POST', urlPath, true)

      const formData = new FormData()
      for (const name in body) {
        formData.append(name, body[name])
      }

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          let percent = (event.loaded / event.total) * 100 || 0
          if (percent >= 100) {
            percent = 99
          }
          progressListener && progressListener(percent)
        }
      }

      setHeaders(xhr, headers)
      xhr.send(formData)
      xhr.onreadystatechange = handleReadyStateChange(xhr, key, resolve, reject, requestTasks)
    })
  }

  upload.cancelUpload = (key) => {
    isCancel = true
    let xhr = requestTasks.get(key)
    if (xhr) {
      xhr.abort()
      requestTasks.delete(key)
    }
  }

  return upload
}

export default createXhrRequest()

// convert base64/URLEncoded data component to raw binary data held in a string
export function dataURItoBlob(dataURI) {
  const byteString = dataURI.split(',')[1]

  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  return new Blob([ia], { type: mimeString })
}
